import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid, Input, Icon, Button } from 'semantic-ui-react';

import { TitledCard } from 'Components/';
import { RECIPE_LISTING_FORM_NAME } from 'Common/FormEnum';
import { RecipeListingFieldEnum as Fields } from 'Common/FieldEnum';
import { makeButtonGroupOptionsFromEnum } from 'Common/FormHelper';

import {
  ReduxFormButtonGroup,
  SelectField,
  InputField,
  Toggle,
} from 'Common/SemanticWrapper';

import { RecipeTable } from 'Common/Components/RecipeTable/RecipeTable';
import {
  RecipeListingSortByEnum,
  RecipeListingReportTypeEnum,
} from '../helpers/Constants';

const reportTypeOptions = makeButtonGroupOptionsFromEnum(
  RecipeListingReportTypeEnum
);

const sortByOptions = makeButtonGroupOptionsFromEnum(RecipeListingSortByEnum);

const RecipeListingFormContainer = (props) => {
  const {
    searchText,
    onSearchTextChange,
    handleShowInactiveChange,
    handleAllergenChange,
    allergenOptions,
    handlAllergenToggleChange,
    handleIngredientChange,
    recipeTableProps,
    handleSearchClick,
  } = props;

  return (
    <Form name={'RecipeListingForm'}>
      <TitledCard title={'Report Parameters'} style={{ width: 1250 }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={7}>
              <ReduxFormButtonGroup
                label={'Report Type'}
                options={reportTypeOptions}
                formName={RECIPE_LISTING_FORM_NAME}
                fieldName={Fields.ReportType}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <ReduxFormButtonGroup
                label={'Sort By'}
                options={sortByOptions}
                formName={RECIPE_LISTING_FORM_NAME}
                fieldName={Fields.SortBy}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
      <TitledCard title={'Recipes'} style={{ width: 1250 }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={7}>
              <Form.Field>
                <Input
                  placeholder="Smartest Lunchroom Search"
                  fluid
                  icon={<Icon name="search" />}
                  iconPosition="left"
                  onChange={onSearchTextChange}
                  value={searchText}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={3} style={{ marginTop: 10, marginLeft: 20 }}>
              <Field
                label={'Show Inactive Only'}
                name={Fields.ShowInactive}
                component={Toggle}
                onChange={handleShowInactiveChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={5} style={{ marginTop: 25 }}>
              <Field
                placeholder={'Allergens'}
                multiple
                name={Fields.Allergens}
                component={SelectField}
                options={allergenOptions}
                selectAllButton
                selectNoneButton
                onChange={handleAllergenChange}
              />
            </Grid.Column>
            <Grid.Column width={3} style={{ marginTop: 35 }}>
              <Field
                label={'Does Not Contain'}
                name={Fields.DoesNotContainAllergen}
                onChange={handlAllergenToggleChange}
                component={Toggle}
              />
            </Grid.Column>
            <Grid.Column width={2} style={{ marginTop: 29, padding: 0 }}>
              <label>Containing Ingredient</label>
            </Grid.Column>
            <Grid.Column width={2} style={{ marginTop: 25, padding: 0 }}>
              <Field
                placeholder={'ID/CN Code'}
                component={InputField}
                name={Fields.CNCode}
                maxLength={8}
                onChange={handleIngredientChange}
              />
            </Grid.Column>
            <Grid.Column width={3} style={{ marginTop: 26, marginLeft: 5 }}>
              <Button
                content={'Search'}
                style={{ paddingLeft: 60, paddingRight: 60 }}
                onClick={handleSearchClick()}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <RecipeTable
          {...recipeTableProps}
          fieldName={Fields.RecipeIds}
          formName={RECIPE_LISTING_FORM_NAME}
        />
      </TitledCard>
    </Form>
  );
};

export const RecipeListingForm = reduxForm({
  form: RECIPE_LISTING_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: false,
})(RecipeListingFormContainer);



// WEBPACK FOOTER //
// ./src/pages/recipelisting/components/RecipeListingForm.js